var SCM = SCM || {};

SCM.LazyLoadAd = (function () {
	return {
		init: init,
		loadATFAds: loadATFAds,
		loadAds: loadAds
	};

    function init() {
        if (!hasDefinedAdSlots()) {
            return;
        }

        var lazyUnits = document.querySelectorAll('.js-adblock-lazy-loading');
        if (lazyUnits.length > 0) {
            window.addEventListener('scroll', function () {
                lazyLoadAds();
            });
        }

        if (!SCM.pubGradeAdsEnabled) {
            loadInterstitialAd();
            loadAds();
        }
        else
        {
            $.getScript(SCM.pubGradeJSLibrary);
            registerPubGradeEvents();
        }
    }

    function hasDefinedAdSlots() {
        return typeof gptAdSlots !== 'undefined';
    }

    function registerPubGradeEvents() {
        var pbgrdFinished = false;
        document.addEventListener('pbgrdFinished', function () { pbgrdFinished = true; });
        SCM.Retry
            .policy()
            .handleResult(function (result) { return result === false; }) // Retry if the result is false
            .waitAndRetry(10, 100)
            .execute(function () { return pbgrdFinished; }) // The function to retry
            .then(function () {
                // The 'pbgrdFinished' event has occurred
                loadAdsAfterPubGradeFinished();
            })
            .catch(function () {
                // The 'pbgrdFinished' event did not occur within the retry limit
                loadAdsAfterPubGradeFinished();
            });
    }

    function loadAdsAfterPubGradeFinished() {
        loadInterstitialAd();
        loadAds();
    }

    function loadAds() {
        loadATFAds();
        lazyLoadAds();
    }   

    // Differentiated as Above the Fold (ATF) or Below the Fold (BTF)
    // ATF: Top leaderboard (_Ad1) and top right rail (_Ad2) are visible immediately.
    // BTF: bottom right rail (_Ad3), bottom leaderboard (_Ad4) are not visible until the user scrolls down.
	function loadATFAds() {
		var atfUnits = document.querySelectorAll('.js-adBlock-parent-wrap > .hide > .js-adblock:not(.js-adblock-lazy-loading)');
        var gptSlots = getGPTSlots();
        if (!gptSlots)
            return;

		for (var i = 0; i < atfUnits.length; i++) {
			var slot = getGPTSlotWithElementId(gptSlots, atfUnits[i].id);

			if (slot !== null) { 
				refreshGPTSlot(slot);
			}
		}
	}

	function lazyLoadAds() {
		var lazyUnits = document.querySelectorAll('.js-adblock-lazy-loading');
        var gptSlots = getGPTSlots();
        if (!gptSlots)
            return;

        for (const lazyUnit of lazyUnits) {
            var slot = getGPTSlotWithElementId(gptSlots, lazyUnit.id);
            var lazyUnitParentWrap = lazyUnit.closest('.js-adBlock-parent-wrap');
            var marginValue = lazyUnit.dataset.lazyLoadMargin ? lazyUnit.dataset.lazyLoadMargin * -1 : -150;

            if (slot !== null && lazyUnitParentWrap !== null && isInViewport(lazyUnitParentWrap, marginValue)) { // load the ad 150px before it enters into the view port
                lazyUnit.classList.remove('js-adblock-lazy-loading');
				refreshGPTSlot(slot);
			}
		}
	}

	function loadInterstitialAd() {
		refreshGPTSlot(gptAdSlots['adInterstitial']);
	}

	function refreshGPTSlot(slot) {
		googletag.cmd.push(function () {
			googletag.pubads().refresh([slot]);
		});
	}

	function getGPTSlotWithElementId(gptSlots, elementId) {
		var slot = gptSlots.find(
			item => item.getSlotElementId() === elementId
		);

		return slot;
	}

	function getGPTSlots() {
		var gptSlots;
		if (window.googletag && googletag.apiReady) {
			gptSlots = googletag.pubads().getSlots();
		}

		return gptSlots;
	}

	function isInViewport(element, threshold, mode) {
		threshold = threshold || 0;
		mode = mode || 'visible';
		var rect = element.getBoundingClientRect();
		var viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
		var above = rect.bottom - threshold < 0;
		var below = rect.top - viewHeight + threshold >= 0;
		return mode === 'above' ? above : mode === 'below' ? below : !above && !below;
	}
})();